/**
 * 資料異動通知（R28，照 CRM utils/dataEvents.ts）
 *
 * 新增／編輯／刪除（含批次、封存、匯入）在 API「成功之後」呼叫 notifyDataChanged(topic)，統一處理：
 * - 儀表板統計重新載入（原本 20 多處各自動態 import pmDashboardStore）
 * - tasks：「我的任務」標記為過期，下次進頁面重抓
 * - 發出事件（@redpanda/utils emitDataChanged）：訂閱者（專案詳情、列表搜尋結果、看板、甘特圖）各自重新載入
 *
 * 注意：對話框是樂觀更新，onClose 在 API 完成前就會觸發，「重新抓資料」一律掛在這個事件上，不要掛在對話框關閉時
 */
import { emitDataChanged, useDataChangedEvent } from '@redpanda/utils';
import { useDashboardStore } from '../stores/pmDashboardStore';
import { useMyTasksStore } from '../stores/pmTaskStore';

// 需求、里程碑不影響儀表板，也沒有其他頁面要跟著重抓，所以沒有主題（有訂閱者時再加）
export type DataTopic = 'projects' | 'packages' | 'tasks' | 'payments' | 'timeEntries' | 'expenses';

export const notifyDataChanged = (topic: DataTopic) => {
  useDashboardStore.getState().fetchDashboardStats();
  if (topic === 'tasks' || topic === 'projects') {
    useMyTasksStore.getState().invalidate();
  }

  emitDataChanged(topic);
};

/** 訂閱資料異動（共用實作 @redpanda/utils dataEvents）；handler 不需要 memo */
export const useDataChanged = (topic: DataTopic | DataTopic[], handler: () => void) => useDataChangedEvent(topic, handler);
